import styled from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "../../styles/theme";

export const FooterSection = styled("footer")`
  background: ${theme.colors.backgroundAlt};
  padding: 3rem 0;
  border-top: 1px solid ${theme.colors.border};
`;

export const Title = styled("h4")`
  font-size: 1.125rem;
  font-family: ${theme.fonts.heading};
  text-transform: capitalize;
  color: ${theme.colors.brown};
  margin-bottom: 1rem;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;
  color: ${theme.colors.brown};

  &:hover,
  &:active,
  &:focus {
    color: ${theme.colors.accent};
  }
`;

export const Extra = styled("section")`
  background: ${theme.colors.backgroundAlt};
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: ${theme.colors.textLight};
  font-size: 14px;
  max-width: 320px;
  line-height: 1.6;
`;

export const ContactLink = styled("a")`
  font-size: 14px;
  color: ${theme.colors.brown};
  cursor: pointer;
  transition: color 0.2s ease-in-out;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  max-width: max-content;
  text-decoration: none;

  &:hover {
    color: ${theme.colors.accent};
  }
`;

export const AddressText = styled("p")`
  font-size: 14px;
  color: ${theme.colors.brown};
  line-height: 1.6;
  margin: 0;
  max-width: 280px;
`;

export const Copyright = styled("span")`
  font-size: 13px;
  color: ${theme.colors.textLight};
  white-space: nowrap;

  @media screen and (max-width: 769px) {
    white-space: normal;
    text-align: center;
  }
`;

export const FooterContainer = styled("div")`
  max-width: 560px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;

  a {
    font-size: 14px;
    color: ${theme.colors.brown};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${theme.colors.accent};
    }
  }

  @media screen and (max-width: 769px) {
    justify-content: center;
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const Language = styled("h4")`
  font-size: 1.125rem;
  font-family: ${theme.fonts.heading};
  text-transform: capitalize;
  color: ${theme.colors.brown};
  margin-bottom: 0.75rem;

  @media screen and (max-width: 414px) {
    padding-top: 0;
  }
`;
